export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="hero" className="relative w-full min-h-[720px] flex items-center overflow-hidden bg-background-100">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-center gap-10 lg:gap-0 py-16 lg:py-0">
        <div className="w-full lg:w-[58%] z-10 flex flex-col justify-center">
          <span className="inline-block text-xs font-label tracking-widest text-primary-600 bg-primary-100/70 px-4 py-1.5 rounded-full mb-5 whitespace-nowrap">
            吃瓜爆料首选
          </span>

          <h1 className="font-heading text-[42px] md:text-[56px] leading-[1.05] text-foreground-950 mb-4">
            51吃瓜网
            <br />
            吃瓜爆料第一站
          </h1>

          <p className="text-lg text-foreground-600 font-label mb-6 max-w-lg">
            带你轻松吃瓜，掌握最新八卦动态
          </p>

          <div className="flex flex-col gap-4 max-w-lg">
            <p className="text-sm leading-relaxed text-foreground-600">
              51吃瓜网是全网最快最全的娱乐八卦资讯聚合平台，覆盖网红事件、明星动态、黑料网曝等热门内容。无论是最新爆料还是深度追踪，这里都是你吃瓜的第一选择。
            </p>
            <p className="text-sm leading-relaxed text-foreground-600">
              我们以闪电速度追踪网络热门事件，汇聚全网最火爆的八卦话题，让每一位吃瓜群众都能第一时间掌握最新瓜情，不错过任何精彩瞬间。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-7 mb-8">
            <div className="text-center">
              <div className="text-[28px] md:text-[34px] font-heading text-primary-600">128</div>
              <div className="text-xs text-foreground-500 mt-1">今日更新</div>
            </div>
            <div className="text-center">
              <div className="text-[28px] md:text-[34px] font-heading text-accent-600">9,999+</div>
              <div className="text-xs text-foreground-500 mt-1">全网爆料</div>
            </div>
            <div className="text-center">
              <div className="text-[28px] md:text-[34px] font-heading text-primary-600">56w</div>
              <div className="text-xs text-foreground-500 mt-1">瓜友在线</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#index"
              onClick={(e) => handleScroll(e, '#index')}
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#app"
              onClick={(e) => handleScroll(e, '#app')}
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-300 text-foreground-800 font-medium text-sm rounded-full hover:bg-foreground-50 transition-all whitespace-nowrap cursor-pointer"
            >
              安装APP
              <i className="ri-download-line"></i>
            </a>
          </div>
        </div>

        <div className="w-full lg:w-[42%] flex items-center justify-center lg:justify-end z-10">
          <div className="relative w-[320px] h-[420px] md:w-[380px] md:h-[500px] rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20vibrant%20editorial%20illustration%20of%20social%20media%20gossip%20and%20entertainment%20news%20theme%2C%20featuring%20colorful%20abstract%20speech%20bubbles%2C%20glowing%20notification%20icons%2C%20trending%20hash%20symbols%2C%20and%20dynamic%20geometric%20shapes%20in%20warm%20coral%20and%20gold%20tones%2C%20modern%20magazine-style%20composition%20with%20clean%20minimal%20background%2C%20high%20contrast%2C%20bold%20graphic%20design%2C%20editorial%20illustration%20style&width=760&height=1000&seq=hero-main-visual&orientation=portrait"
              alt="51吃瓜网 吃瓜爆料第一站 娱乐资讯平台"
              title="51吃瓜网 吃瓜爆料第一站"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}